var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-child-head",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.191,
    height: 16.196,
    viewBox: "0 0 16.191 16.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5292",
    "data-name": "Path 5292",
    d: "M16.2,7.76a2.362,2.362,0,0,0-1.45-2.177,6.748,6.748,0,0,0-13.294,0,2.362,2.362,0,0,0,.755,4.534,7.158,7.158,0,0,0,1.4,1.994,6.011,6.011,0,0,0-1.533,3.326.675.675,0,0,0,.586.754.738.738,0,0,0,.084.005.675.675,0,0,0,.669-.59,4.673,4.673,0,0,1,1.225-2.613A6.038,6.038,0,0,0,8.1,14.171,6.033,6.033,0,0,0,11.555,13a4.671,4.671,0,0,1,1.22,2.606.675.675,0,0,0,.669.591.718.718,0,0,0,.084-.005.675.675,0,0,0,.586-.753,6.006,6.006,0,0,0-1.526-3.319,7.168,7.168,0,0,0,1.405-2A2.362,2.362,0,0,0,16.2,7.76Zm-2.532.994a.67.67,0,0,0-.754.439A5.7,5.7,0,0,1,8.1,12.822,5.7,5.7,0,0,1,3.288,9.192a.671.671,0,0,0-.754-.439,1.084,1.084,0,0,1-.17.02,1.012,1.012,0,0,1-.182-2.006.675.675,0,0,0,.551-.593,5.372,5.372,0,0,1,2.756-4.15,2.75,2.75,0,0,0-.015,1.311,2.7,2.7,0,0,0,5.188.215.659.659,0,0,0-.638-.85h-.1a.585.585,0,0,0-.544.426A1.35,1.35,0,1,1,8.1,1.35a5.384,5.384,0,0,1,5.368,4.825.675.675,0,0,0,.551.593,1.012,1.012,0,0,1-.182,2.006,1.084,1.084,0,0,1-.17-.018Z",
    transform: "translate(-0.008 0)",
    fill: "#bbc6d1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_383",
    "data-name": "Ellipse 383",
    cx: 1.012,
    cy: 1.012,
    r: 1.012,
    transform: "translate(5.393 6.749)",
    fill: "#bbc6d1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_384",
    "data-name": "Ellipse 384",
    cx: 1.012,
    cy: 1.012,
    r: 1.012,
    transform: "translate(8.767 6.749)",
    fill: "#bbc6d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfant);
export default __webpack_public_path__ + "static/media/infant.73fed776.svg";
export { ForwardRef as ReactComponent };